import { GetServerSideProps } from "next";
import api from "../../lib/utils/api";
import { Locale } from "../../lib/types";
import { mapHowItWorksPageData } from "../../lib/utils/mappers";
import styles from '../../styles/HowItWorks.module.css'
import cmsEndpoints from "../../lib/utils/cmsEndpoints";
import HowItWorksPageStep from "../../components/HowItWorks/HowItWorksPageStep";
import { Col, Container, Row } from "react-bootstrap";
import { PageHead } from "../../components/PageHead";

export const getServerSideProps: GetServerSideProps = async (context) => {

  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  const locale = context.locale as Locale

  const pageData = await api.get(cmsEndpoints.howItWorksPage())

  const page = mapHowItWorksPageData(pageData?.data?.data?.attributes, locale)

  return {
    props: {
      page
    }
  }
}

const HowItWorks = (props: any) => {
  return (
    <>
      <PageHead title={props.page?.title} description={props.page?.description} />
      <div
        className={styles.wrapper}
        style={{ ...(props.page.backgroundPattern ? { backgroundImage: `url(${props.page.backgroundPattern})` } : {}) }}
      >
        <Container className={styles.container}>
          <Row className={styles.content}>
            <Col>
              {props.page.title && <h1 className='pb-5 text-center'>{props.page.title}</h1>}
              {props.page.description && <div className="text-center">{props.page.description}</div>}
              {props.page.step.length > 0 && (
                <div className='w-100' style={{ paddingTop: '7rem', paddingBottom: '7rem' }}>
                  {props.page.step.map((_step, index) => (
                    <HowItWorksPageStep
                      key={index}
                      title={_step.title}
                      description={_step.description}
                      imagePosition={_step.imagePosition}
                      image={_step.image}
                      variant={_step.variant}
                      showArrowBelow={_step.showArrowBelow}
                    />
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default HowItWorks
